// apps/nos/client/src/components/Sidebar/SidebarFlavorRow.tsx
import type { KeyboardEvent } from "react";
import { cn } from "@/utils/cn";
import { Icon } from "@/components/Icon/Icon";
import type { SidebarFlavor } from "@/utils/types/flavor";

type SidebarFlavorRowProps = {
  flavor: SidebarFlavor;
  starred?: boolean;
  active: boolean;
  onSelect: (flavor: SidebarFlavor) => void;
};

export function SidebarFlavorRow({
  flavor,
  starred,
  active,
  onSelect,
}: SidebarFlavorRowProps) {
  const isStarred = !!(flavor.starred ?? starred);

  const onRowClick = () => onSelect(flavor);

  const onRowKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onSelect(flavor);
    }
  };

  return (
    <div
      className={cn("sidebar-flavor-row", active && "active")}
      role="button"
      tabIndex={0}
      onClick={onRowClick}
      onKeyDown={onRowKeyDown}
    >
      <span className={cn("leading", isStarred ? "lead-starred" : "lead-recent")}>
        {isStarred ? <Icon name="star-fill" size={12} /> : <span className="leading-dot" />}
      </span>
      <div className="body">
        <span className="body-name">{flavor.name}</span>
        <span className="body-updated">{flavor.updated}</span>
      </div>
    </div>
  );
}
